module.exports = __webpack_public_path__ + "img/intention-recognition.8cf2df91.png";